/*
  Loriatech — Modale « Toutes les langues » (snippet ltp-languages).
  Sorti dans un asset chargé via <script defer> : le {% javascript %} d'un
  snippet n'est pas exécuté de façon fiable par Shopify (contrairement aux
  sections). Ce fichier est partagé par le globe home (lt-langues-map) et le
  globe page produit (lt-product-coverage-map).
*/
(function () {
  function init() {
    var dialog = document.getElementById('ltp-langs-dialog');
    if (!dialog || dialog.dataset.ltpLangsBound === '1') return;
    dialog.dataset.ltpLangsBound = '1';

    var openers = document.querySelectorAll('[data-ltp-langs-open]');
    var closer = dialog.querySelector('[data-ltp-langs-close]');
    var search = dialog.querySelector('[data-ltp-langs-search]');
    var empty = dialog.querySelector('[data-ltp-langs-empty]');
    var groups = dialog.querySelectorAll('[data-ltp-langs-group]');
    var countEl = dialog.querySelector('.ltp-langs__count');
    var defaultCountText = countEl ? countEl.textContent : '';
    var filterTimer = null;
    var lastQuery = '';

    function open() {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (search) search.focus(); }, 80);
    }
    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.body.style.overflow = '';
      if (search) { search.value = ''; search.classList.remove('is-searching'); filter(''); }
    }

    function updateCount(q, matches) {
      if (!countEl) return;
      var isFiltered = q !== '';
      var newText = isFiltered ? String(matches) : defaultCountText;
      if (countEl.textContent !== newText) {
        countEl.textContent = newText;
        countEl.classList.remove('is-bumping');
        void countEl.offsetWidth;
        countEl.classList.add('is-bumping');
      }
      countEl.classList.toggle('is-filtered', isFiltered);
    }

    function filter(q) {
      q = (q || '').trim().toLowerCase();
      lastQuery = q;
      var totalMatches = 0;
      var anyVisible = false;

      if (search) search.classList.toggle('is-searching', q !== '');

      groups.forEach(function (group) {
        var cards = group.querySelectorAll('[data-ltp-lang]');
        var visibleInGroup = 0;
        var enteringCards = [];

        cards.forEach(function (card) {
          var key = card.getAttribute('data-ltp-lang') || '';
          var show = q === '' || key.indexOf(q) !== -1;
          var wasHidden = card.hidden;

          if (show) {
            visibleInGroup++;
            totalMatches++;

            if (wasHidden) {
              card.hidden = false;
              card.classList.remove('is-filter-out');
              enteringCards.push(card);
            } else {
              card.classList.remove('is-filter-out');
            }
          } else {
            if (!card.classList.contains('is-filter-out')) {
              card.classList.add('is-filter-out');
              (function (c) {
                setTimeout(function () {
                  if (c.classList.contains('is-filter-out') && lastQuery !== '' && (c.getAttribute('data-ltp-lang') || '').indexOf(lastQuery) === -1) {
                    c.hidden = true;
                  }
                }, 220);
              })(card);
            }
          }
        });

        enteringCards.forEach(function (card, i) {
          card.classList.remove('is-filter-in');
          void card.offsetWidth;
          card.style.animationDelay = Math.min(i, 8) * 24 + 'ms';
          card.classList.add('is-filter-in');
          setTimeout(function () {
            card.classList.remove('is-filter-in');
            card.style.animationDelay = '';
          }, 380 + Math.min(i, 8) * 24);
        });

        var shouldHide = visibleInGroup === 0 && q !== '';
        group.classList.toggle('is-group-hidden', shouldHide);
        if (visibleInGroup > 0) anyVisible = true;
      });

      if (empty) {
        var showEmpty = !anyVisible && q !== '';
        if (showEmpty && empty.hidden) {
          empty.hidden = false;
        } else if (!showEmpty && !empty.hidden) {
          empty.hidden = true;
        }
      }

      updateCount(q, totalMatches);

      if (q !== '' && totalMatches === 1) {
        groups.forEach(function (group) {
          var visible = group.querySelectorAll('[data-ltp-lang]:not([hidden]):not(.is-filter-out)');
          if (visible.length === 1) {
            var card = visible[0];
            card.classList.remove('is-match');
            void card.offsetWidth;
            card.classList.add('is-match');
            setTimeout(function () { card.classList.remove('is-match'); }, 650);
          }
        });
      }
    }

    openers.forEach(function (opener) { opener.addEventListener('click', open); });
    if (closer) closer.addEventListener('click', close);
    if (search) {
      search.addEventListener('input', function (e) {
        var v = e.target.value;
        if (filterTimer) clearTimeout(filterTimer);
        filterTimer = setTimeout(function () { filter(v); }, 40);
      });
    }

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });
    dialog.addEventListener('close', function () {
      document.body.style.overflow = '';
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && search && search.value) {
        e.preventDefault();
        search.value = '';
        filter('');
        search.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
